import React from 'react';

export function GuaSha() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">GUA SHA FACIAL</h1>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Tratamiento Gua Sha</h2>
            <p className="text-gray-600">
              El Gua Sha es una técnica de masaje que proviene de la medicina tradicional china (MTC).
              <br /><br />
              Actualmente, las maniobras de masaje se han ido suavizando y se utilizan piedras de distintas formas y tamaños, que se adaptan perfectamente a los contornos de la piel.
              <br /><br />
              Es un tratamiento personalizado.
              <br />
              Incluye producto 100% natural.
              <br />
              No incluye extracción ni depilación de cejas y/o labio.
              <br /><br />
              <strong>Duración:</strong> 60 min
              <br />
              <strong>Precio:</strong> 65€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}